import '@babel/polyfill';

import './public_path';
import Vue from 'vue';
import VueCookie from 'vue-cookie';
import MarketingFlashcards from '@components/marketingFlashcards';
import Vuex from 'vuex';
import flashcards from './store/modules/flashcards';
import attachments from './store/modules/attachments';
import purchaseOrders from './store/modules/purchaseOrders';
import productVars from './store/modules/productVars';
import session from './store/modules/session';
import assetAssociations from './store/modules/assetAssociations';
import Axios from 'axios';
import disableable from '@directives/disableable';
import RouterLink from '@components/marketing/fakeRouterLink';

Vue.component('router-link', RouterLink);
Vue.directive('disableable', disableable);
Vue.use(VueCookie);
Vue.use(Vuex);
Vue.config.productionTip = false;

let store = new Vuex.Store({
  modules: {
    assetAssociations,
    attachments,
    flashcards,
    productVars,
    session,
    purchaseOrders,
  },
  state: {
    flashcardIds: '',
    bundleIdentifier: '',
  },
  actions: {
    createFlashcardSession({ commit }) {
      let url;
      if( process.env.WEB_ENV == 'production' || process.env.WEB_ENV == 'staging' ) {
        url = 'https://hlt-web-service.herokuapp.com/api/web/v1/marketing_session?ids=' + this.state.flashcardIds + '&bundle_identifier=' + this.state.bundleIdentifier;
      } else {
        url = 'https://localhost:3000/api/web/v1/marketing_session?ids=' + this.state.flashcardIds + '&bundle_identifier=' + this.state.bundleIdentifier;
      }
      Axios.get(url).then(function(response) {
        commit('flashcards/setFlashcardSession', response.data.session);
        commit('flashcards/setFlashcards', { records: response.data.flashcards });
      });
    },
  },
  mutations: {
    setFlashcardIds(state, ids) {
      state.flashcardIds = ids;
    },
    setBundleIdentifier(state, bundleIdentifier) {
      state.bundleIdentifier = bundleIdentifier;
    },
  },
  getters: {
    flashscardIds: state => state.flashcardIds,
    bundleIdentifier: state => state.bundleIdentifier,
  },
});


function parseQuery(queryString) {
    var query = {};
    var pairs = (queryString[0] === '?' ? queryString.substr(1) : queryString).split('&');
    for (var i = 0; i < pairs.length; i++) {
        var pair = pairs[i].split('=');
        query[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1] || '');
    }
    return query;
}

window.onload = function() {
  Vue.component('completed-view', { template: '#completed-template' });
  new Vue({
    el: '#marketing-flashcards',
    store: store,
    beforeMount() {
      let qs = parseQuery(window.location.search);
      let fids;
      let attrs = this.$el.attributes['flashcard-ids'];
      if (attrs && attrs.textContent != '') {
        fids = this.$el.attributes['flashcard-ids'].textContent;
      } else if (qs['fid']) {
        fids = qs['fid'];
      } else {
        fids = null;
      }
      this.$store.commit('setFlashcardIds', fids);
      if (this.$el.attributes['bundle-identifier']) {
        this.$store.commit('setBundleIdentifier', this.$el.attributes['bundle-identifier'].textContent);
      }
    },
    mounted() {
    },
    render: h => h(MarketingFlashcards),
  });
};
